import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { apiFetch } from '@/core';
import { ReviewReminderFormType } from '../types';
import env from '@/env';
import { Reminder } from '@/common';

export const reviewReminder = async ({
  id,
  data,
}: {
  id: string;
  data: ReviewReminderFormType;
}): Promise<Reminder> => {
  const fetchResponse = await apiFetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/reminders/${id}/review`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        endType: data.endType,
      }),
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as Reminder;
  return response;
};
